const normalizeCurrencyCode = (value) => {
  if (typeof value !== "string") return "";
  return value.trim().toUpperCase();
};

export const resolveSupplierCurrencyCode = ({ asiLiveRawData, orderItem } = {}) => {
  const candidates = [
    asiLiveRawData?.LowestPrice?.CurrencyCode,
    orderItem?.CurrencyCode ?? orderItem?.currencyCode,
    asiLiveRawData?.HighestPrice?.CurrencyCode,
    asiLiveRawData?.Currencies?.[0],
  ];

  return candidates.map(normalizeCurrencyCode).find(Boolean) || "";
};

export default resolveSupplierCurrencyCode;
